/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { FilterableByLocation, LocationFilterOptions } from '../interface/models';

export const isLocationFilterMatching = <T extends FilterableByLocation>(
  cmsItem: T,
  locationFilterOptions: LocationFilterOptions,
): boolean => {
  if (!cmsItem.location_filter_enabled || !cmsItem.location_filter) {
    return false;
  }

  const { states, cities } = cmsItem.location_filter;
  const { state: currentState, city: currentCity } = locationFilterOptions;

  const hasStateFilter = states && states.length > 0;
  const hasCityFilter = cities && cities.length > 0;

  if (!hasStateFilter && !hasCityFilter) {
    return true;
  }

  if (hasCityFilter) {
    const stateMatches = !hasStateFilter || (currentState ? states.includes(currentState) : false);
    const cityMatches = currentCity ? cities.includes(currentCity) : false;
    return stateMatches && cityMatches;
  }

  if (hasStateFilter) {
    return currentState ? states.includes(currentState) : false;
  }

  return false;
};
